export default __webpack_public_path__ + "static/media/sitting-icon.dcb614b2.png";